import React from 'react';
import classnames from 'classnames';

import { translate as t } from '../../lib/I18n';

import Icon from '../general/Icon';
import LoginLink from './LoginLink';
import RegisterLink from './RegisterLink';
import PureRenderComponent from '../PureRenderComponent';
import DropDown from './DropDown';
import DropDownItem from './DropDownItem';


class LoggedOutLinks extends PureRenderComponent {

    state = { showDropdown: false };

    _toggleDropdown = () => this.setState({ showDropdown: !this.state.showDropdown });

    render () {
        const classNames = classnames('navlink__login btn like-link', {
            'active': this.state.showDropdown
        });

        const ariaExpandedState = this.state.showDropdown ? "true" : "false";

        return (
            <li className="pull-right nav-list__item nav-list__item--login">

                <LoginLink />

                <RegisterLink />

                <button type="button"
                        aria-label={ t('ariaLabel.showLoginDropdown') }
                        aria-haspopup="true"
                        aria-expanded={ ariaExpandedState }
                        className={ classNames }
                        onClick={ this._toggleDropdown }>
                    <Icon icon="user" />
                    <span className="sr-only">{ t('account.login') }</span>
                    <Icon icon="dropdown" />
                </button>

                <DropDown show={ this.state.showDropdown }>
                    <DropDownItem><LoginLink onClick={ this._toggleDropdown } /></DropDownItem>
                    <DropDownItem><RegisterLink onClick={ this._toggleDropdown } /></DropDownItem>
                </DropDown>
            </li>
        );
    }



}

export default LoggedOutLinks;




// WEBPACK FOOTER //
// ./src/components/nav/LoggedOutLinks.js